import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=b3e8c58e&scoped=true&"
import script from "./Countdown.vue?vue&type=script&lang=js&"
export * from "./Countdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e8c58e",
  null
  
)

export default component.exports